import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as state from './ai-settings.state'

export const State = createFeatureSelector<state.State>('aiSettings')

export const selectAISettingsLoaded = createSelector(State, (state: state.State) => state.isLoaded)
export const selectAISettingsIsSaving = createSelector(State, (state: state.State) => state.isSaving)
export const selectAISettings = createSelector(State, (state: state.State) => state.settings)
